import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { LieFormSnp, MenuClasificacionLieSnp, MenuInstitucionSedeLieSnp, TemasLieSnp } from '@/shared/model/snp/lie.model';
import CatalogosSnp from '@/shared/model/snp/catalogos-snp.factory';
import SeleccionTablasComponent from '@/components/seleccion-tablas/seleccion-tablas.vue';
import { mixins } from 'vue-class-component';
import { v4 as uuidv4 } from 'uuid';
import { obtenerFechaHoyYYYYMMDD } from '@/shared/date/date-utils';

const validations = function () {
  return {
    lieForm: {
      nombreDeLinea: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(250),
      },
      clasificacion: {
        required,
      },
      fechaAlta: {
        required,
      },
      temasPrioritariosPeciti: {
        required,
      },
      instituciones: {
        required,
      },
      justificacion: {
        required,
        minLength: minLength(25),
        maxLength: maxLength(2500),
      },
    },
  };
};

@Component({
  validations: validations,
  components: {
    seleccionTablas: SeleccionTablasComponent,
  },
})
export default class LieRegistroComponent extends mixins(ApeironComponent) {
  @Prop({ required: true })
  public solucion: Solucion;

  @Prop({ required: true })
  public solicitud: Solicitud;

  @Prop({
    required: false,
    default: function () {
      return new LieFormSnp();
    },
  })
  public lieEdicion: LieFormSnp;

  public lieForm: LieFormSnp = new LieFormSnp();
  public fechaHoy = '';

  public instituciones: Array<MenuInstitucionSedeLieSnp> = [];
  public clasificaciones: Array<MenuClasificacionLieSnp> = [];
  public inicialTemasIncidenciaNacional: Array<TemasLieSnp> = [];
  public temasIncidenciaNacional: Array<TemasLieSnp> = [];
  public comparacionTemasIncidenciaNacional = ['temaPeciti'];

  public mounted(): void {
    this.iniciarComponente(false);
  }

  @Watch('lieEdicion')
  public watchLieEdicion(): void {
    this.iniciarComponente(false);
  }

  public iniciarComponente(limpiarLie: boolean): void {
    this.fechaHoy = obtenerFechaHoyYYYYMMDD();
    this.clasificaciones = [];
    CatalogosSnp.obtenerClasificacionesLies().forEach(it => {
      this.clasificaciones.push({ value: it, text: it.nombre });
    });

    this.instituciones = [];

    if (this.solicitud?.programa?.instituciones) {
      this.solicitud.programa.instituciones.forEach(institucion => {
        (institucion.sedes ?? []).forEach(sede => {
          const institucionSede = `${institucion.nombreInstitucion} || ${sede.nombreDependencia} (${sede.sede})`;
          this.instituciones.push({
            value: {
              claveInstitucion: institucion.claveInstitucion,
              claveDependencia: sede.claveDependencia,
              nombre: institucionSede,
            },
            text: institucionSede,
          });
        });
      });
    }

    if (this.lieEdicion?.cveLinea && !limpiarLie) {
      this.lieForm = this.lieEdicion;
      this.inicialTemasIncidenciaNacional = this.lieForm.temasPrioritariosPeciti;
      let temasDisponibles = CatalogosSnp.obtenerTemasPrioritarios();
      this.lieForm.temasPrioritariosPeciti.forEach(tema => {
        temasDisponibles = temasDisponibles.filter(opcion => opcion.idTemaPeciti != tema.idTemaPeciti);
      });
      this.temasIncidenciaNacional = temasDisponibles;
    } else {
      this.lieForm = new LieFormSnp();
      this.lieForm.cveLinea = uuidv4();
      this.inicialTemasIncidenciaNacional = [];
      this.temasIncidenciaNacional = CatalogosSnp.obtenerTemasPrioritarios();
    }
  }

  public limpiarDatos(): void {
    this.iniciarComponente(true);
  }

  public guardarLie(): void {
    if (!this.readOnly) {
      if (!this.formularioIsInvalid) {
        this.agregarLie();
      } else {
        this.alertService().showWarning(this, this.$t('apeironGwApp.lieSnp.form.formularioInvalido').toString());
      }
    }
  }

  @Emit('agregarLie')
  public agregarLie(): LieFormSnp {
    const lie = { ...this.lieForm };

    this.limpiarDatos();

    return lie;
  }

  get formularioIsInvalid(): boolean {
    return this.$v.$invalid;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }
}
